import { TABS } from '@/pages/Products/CloudFlare/ManageCloudFlareHandler/ManageCloudFlareHandler.types';
import { CloudflareActionTypes } from './cloudflare.types';

export const initialState = {
  loading: false,
  loaded: false,
  list: [],
  activateCdnStatus: null,
  lastActivation: {},
  loadingActivation: false,
  domainsError: false,
  activeDomains: {
    list: [],
    loading: false,
    status: null,
  },
  features: {
    status: {},
    loading: false,
    requestStatus: null,
    updateStatus: null,
  },
  purgeCache: {
    loading: false,
    status: null,
  },
  specificCheckedDomain: {},
  analysis: {
    finished: null,
    lastAnalysis: null,
    loadingHistory: false,
    speedHistory: {
      lastAnalysisId: null,
      loading: false,
      tests_left: null,
      status: null,
    },
    visitors: {
      loading: false,
      unique_visitors: null,
      requests: null,
      status: null,
    },
  },
  rules: {
    loading: false,
    status: null,
    submitAction: 'create',
    list: [],
    create: {
      loading: false,
      status: null,
      blockedUntil: null,
    },
    delete: {
      loading: false,
      status: null,
    },
    edit: {
      loading: false,
      status: null,
    },
    ruleData: {
      ruleId: '',
      description: '',
      lockType: '',
      value: '',
      enabled: false,
    },
  },
};

const cloudflareReducer = (state = initialState, action) => {
  switch (action.type) {
    case CloudflareActionTypes.DOMAINS_ERROR: {
      return {
        ...state,
        domainsError: action.payload.bool,
      };
    }
    case CloudflareActionTypes.DOMAINS_SET: {
      return {
        ...state,
        list: action.payload,
        loaded: true,
      };
    }
    case CloudflareActionTypes.DOMAINS_LOADING: {
      return {
        ...state,
        loading: action.payload,
        loaded: !action.payload,
        lastActivation: action.payload ? {} : state.lastActivation,
        list: action.payload ? [] : state.list,
        domainsError: action.payload ? false : state.domainsError,
      };
    }
    case CloudflareActionTypes.LOADING_ACTIVATION: {
      return {
        ...state,
        loadingActivation: action.payload,
        activateCdnStatus: null,
      };
    }
    case CloudflareActionTypes.SET_ACTIVATED_DOMAIN: {
      const newList = [...state.list];
      const domainIndex = newList.findIndex(listItem => listItem.domain === action.payload.domain.domain);

      if (domainIndex >= 0 && action.payload.domain.requestStatus === 'success') {
        const statusToPendingActivate = ['nonexistent', 'inactive', 'inactive_delay', 'pending'];
        newList[domainIndex] = {
          ...newList[domainIndex],
          domain_origin: action.payload.domain.domain_origin || newList[domainIndex].domain_origin,
          status: (statusToPendingActivate.includes(newList[domainIndex].status))
            ? 'pending'
            : 'pendingDeactivation',
        };
      }

      return {
        ...state,
        lastActivation: action.payload.domain,
        list: newList,
      };
    }
    case CloudflareActionTypes.LOADING_ACTIVATION_SUCCESS: {
      return {
        ...state,
        activateCdnStatus: 'success',
      };
    }
    case CloudflareActionTypes.LOADING_ACTIVATION_FAILURE: {
      return {
        ...state,
        activateCdnStatus: 'failure',
      };
    }
    case CloudflareActionTypes.RESET_ACTIVATED_DOMAIN_STATUS: {
      return {
        ...state,
        activateCdnStatus: null,
      };
    }
    case CloudflareActionTypes.SET_ACTIVE_DOMAINS: {
      return {
        ...state,
        activeDomains: {
          ...state.activeDomains,
          list: action.payload.data,
        },
      };
    }
    case CloudflareActionTypes.ACTIVE_DOMAINS_SUCCESS: {
      return {
        ...state,
        activeDomains: {
          ...state.activeDomains,
          status: 'success',
        },
      };
    }
    case CloudflareActionTypes.ACTIVE_DOMAINS_FAILURE: {
      return {
        ...state,
        activeDomains: {
          ...state.activeDomains,
          status: 'failure',
        },
      };
    }
    case CloudflareActionTypes.ACTIVE_DOMAINS_RESET_STATUS: {
      return {
        ...state,
        activeDomains: {
          ...state.activeDomains,
          status: null,
        },
      };
    }
    case CloudflareActionTypes.ACTIVE_DOMAINS_REQUEST_LOADING: {
      const status = action.payload === true ? null : state.activeDomains.status;

      return {
        ...state,
        activeDomains: {
          ...state.activeDomains,
          loading: action.payload,
          status,
        },
      };
    }
    case CloudflareActionTypes.SET_STATUS_OF_FEATURES: {
      return {
        ...state,
        features: {
          ...state.features,
          status: action.payload,
        },
      };
    }
    case CloudflareActionTypes.STATUS_OF_FEATURES_SUCCESS: {
      return {
        ...state,
        features: {
          ...state.features,
          requestStatus: 'success',
        },
      };
    }
    case CloudflareActionTypes.STATUS_OF_FEATURES_RESET_REQUEST_STATUS: {
      return {
        ...state,
        features: {
          ...state.features,
          requestStatus: null,
        },
      };
    }
    case CloudflareActionTypes.STATUS_OF_FEATURES_FAILURE: {
      return {
        ...state,
        features: {
          ...state.features,
          requestStatus: 'failure',
        },
      };
    }
    case CloudflareActionTypes.STATUS_OF_FEATURES_LOADING: {
      const requestStatus = action.payload === true ? null : state.features.requestStatus;
      return {
        ...state,
        features: {
          ...state.features,
          loading: action.payload,
          requestStatus,
        },
      };
    }
    case CloudflareActionTypes.UPDATE_FEATURE_LOADING: {
      const { feature, isLoading } = action.payload;

      return {
        ...state,
        features: {
          ...state.features,
          updateStatus: isLoading ? null : state.features.updateStatus,
          status: {
            ...state.features.status,
            [feature]: {
              ...state.features.status[feature],
              loading: isLoading,
            },
          },
        },
      };
    }
    case CloudflareActionTypes.SET_UPDATE_FEATURE: {
      const { feature, data, status } = action.payload;
      let newStatus = state.features.status[feature].status;

      if (status) {
        newStatus = status === 'on';
      }

      return {
        ...state,
        features: {
          ...state.features,
          status: {
            ...state.features.status,
            [feature]: {
              ...state.features.status[feature],
              blocked_until: data.data.blocked_until,
              status: newStatus,
            },
          },
        },
      };
    }
    case CloudflareActionTypes.UPDATE_FEATURE_SUCCESS: {
      return {
        ...state,
        features: {
          ...state.features,
          updateStatus: 'success',
        },
      };
    }
    case CloudflareActionTypes.UPDATE_FEATURE_FAILURE: {
      return {
        ...state,
        features: {
          ...state.features,
          updateStatus: 'failure',
        },
      };
    }
    case CloudflareActionTypes.RESET_UPDATE_FEATURE_STATUS: {
      return {
        ...state,
        features: {
          ...state.features,
          updateStatus: null,
        },
      };
    }
    case CloudflareActionTypes.REQUEST_PURGE_CACHE_SUCCESS: {
      return {
        ...state,
        purgeCache: {
          ...state.purgeCache,
          status: 'success',
        },
      };
    }
    case CloudflareActionTypes.REQUEST_PURGE_CACHE_FAILURE: {
      return {
        ...state,
        purgeCache: {
          ...state.purgeCache,
          status: 'failure',
        },
      };
    }
    case CloudflareActionTypes.REQUEST_PURGE_CACHE_LOADING: {
      const status = action.payload === true ? null : state.purgeCache.status;

      return {
        ...state,
        purgeCache: {
          status,
          loading: action.payload,
        },
      };
    }
    case CloudflareActionTypes.SET_PURGE_CACHE: {
      const { data } = action.payload;

      if (!data.blocked_until) return state;

      return {
        ...state,
        features: {
          ...state.features,
          status: {
            ...state.features.status,
            purge_cache: {
              blocked_until: data.blocked_until,
            },
          },
        },
      };
    }
    case CloudflareActionTypes.SITES_WIZARD_SET_DOMAIN_DATA: {
      return {
        ...state,
        specificCheckedDomain: { ...action.payload },
      };
    }
    case CloudflareActionTypes.SPEED_ANALYTICS_REQUEST: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          finished: null,
          speedHistory: {
            ...state.analysis.speedHistory,
            lastAnalysisId: action.payload.clearLastAnalysisId
              ? null
              : state.analysis.speedHistory.lastAnalysisId,
          },
        },
      };
    }
    case CloudflareActionTypes.SET_LOADING_ANALYSIS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
            loading: action.payload.bool,
          },
          visitors: {
            ...state.analysis.visitors,
            loading: action.payload.bool,
          },
        },
      };
    }
    case CloudflareActionTypes.SPEED_LOADING_HISTORY: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          loadingHistory: action.payload,
        },
      };
    }
    case CloudflareActionTypes.SPEED_ANALYTICS_SET_HISTORY: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          finished: TABS.speed,
          speedHistory: {
            ...state.analysis.speedHistory,
            ...action.payload,
            status: 'success',
          },
        },
      };
    }
    case CloudflareActionTypes.SPEED_ANALYTICS_GET_HISTORY_FAILED: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
            status: 'failure',
          },
        },
      };
    }
    case CloudflareActionTypes.ANALYTICS_SUCCEEDED_REQUEST: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
          },
        },
      };
    }
    case CloudflareActionTypes.ANALYTICS_FAILED_REQUEST: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
          },
        },
      };
    }
    case CloudflareActionTypes.RESET_HISTORY_REQUEST_STATUS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
            status: null,
          },
        },
      };
    }
    case CloudflareActionTypes.SPEED_ANALYTICS_SET_LAST_ANALYSIS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          lastAnalysis: action.payload.data,
        },
      };
    }
    case CloudflareActionTypes.SPEED_ANALYTICS_SET_LAST_ANALYSIS_ID: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          speedHistory: {
            ...state.analysis.speedHistory,
            lastAnalysisId: action.payload.id,
            tests_left: action.payload.tests_left,
          },
        },
      };
    }
    case CloudflareActionTypes.SET_VISITOR_ANALYSIS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          visitors: {
            ...state.analysis.visitors,
            unique_visitors: action.payload.unique_visitors,
            requests: action.payload.requests,
          },
        },
      };
    }

    case CloudflareActionTypes.SET_VISITORS_SUCCESS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          visitors: {
            ...state.analysis.visitors,
            status: 'success',
          },
        },
      };
    }

    case CloudflareActionTypes.SET_VISITORS_FAILURE: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          visitors: {
            ...state.analysis.visitors,
            status: 'failure',
          },
        },
      };
    }

    case CloudflareActionTypes.RESET_VISITOR_ANALYSIS: {
      return {
        ...state,
        analysis: {
          ...state.analysis,
          visitors: {
            ...initialState.analysis.visitors,
          },
        },
      };
    }

    case CloudflareActionTypes.SET_ADD_RULE_LOADING: {
      return {
        ...state,
        rules: {
          ...state.rules,
          create: {
            ...state.rules.create,
            loading: action.payload,
          },
        },
      };
    }

    case CloudflareActionTypes.ADD_RULE_SUCCESS: {
      return {
        ...state,
        rules: {
          ...state.rules,
          create: {
            ...state.rules.create,
            status: 'success',
            blockedUntil: action.payload.blockedUntil,
          },
          list: [
            ...state.rules.list,
            action.payload.newRule,
          ],
        },
      };
    }

    case CloudflareActionTypes.ADD_RULE_FAILURE: {
      return {
        ...state,
        rules: {
          ...state.rules,
          create: {
            ...state.rules.create,
            blockedUntil: action.payload.blockedUntil,
            status: 'failure',
          },
        },
      };
    }

    case CloudflareActionTypes.RESET_ADD_RULE_STATE: {
      return {
        ...state,
        rules: {
          ...state.rules,
          create: {
            ...state.rules.create,
            status: null,
            loading: false,
          },
        },
      };
    }

    case CloudflareActionTypes.RESET_DELETE_RULE_STATE: {
      return {
        ...state,
        rules: {
          ...state.rules,
          delete: {
            ...state.rules.delete,
            status: null,
            loading: false,
          },
        },
      };
    }

    case CloudflareActionTypes.RESET_GET_RULES_STATUS: {
      return {
        ...state,
        rules: {
          ...state.rules,
          status: null,
        },
      };
    }

    case CloudflareActionTypes.RESET_EDIT_RULE_STATE: {
      return {
        ...state,
        rules: {
          ...state.rules,
          edit: {
            ...state.rules.edit,
            status: null,
            loading: false,
          },
        },
      };
    }

    case CloudflareActionTypes.SET_RULES: {
      return {
        ...state,
        rules: {
          ...state.rules,
          rulesGroupId: action.payload.rulesGroupId,
          list: action.payload.rulesList,
        },
      };
    }

    case CloudflareActionTypes.SET_RULES_LOADING: {
      const loading = action.payload;

      return {
        ...state,
        rules: {
          ...state.rules,
          delete: {
            ...state.rules.delete,
            loading,
          },
        },
      };
    }

    case CloudflareActionTypes.DELETE_RULE_LOADING: {
      const loading = action.payload;

      return {
        ...state,
        rules: {
          ...state.rules,
          delete: {
            ...state.rules.delete,
            loading,
          },
        },
      };
    }

    case CloudflareActionTypes.GET_RULES_SUCCESS: {
      return {
        ...state,
        rules: {
          ...state.rules,
          status: 'success',
        },
      };
    }

    case CloudflareActionTypes.GET_RULES_FAILURE: {
      return {
        ...state,
        rules: {
          ...state.rules,
          status: 'failure',
        },
      };
    }

    case CloudflareActionTypes.DELETE_RULE_SUCCESS: {
      return {
        ...state,
        rules: {
          ...state.rules,
          list: action.payload,
          delete: {
            ...state.rules.delete,
            status: 'success',
          },
        },
      };
    }

    case CloudflareActionTypes.EDIT_RULE_SET: {
      return {
        ...state,
        rules: {
          ...state.rules,
          submitAction: 'create',
          edit: {
            ...state.rules.edit,
            status: action.payload.success ? 'success' : null,
          },
          list: action.payload.newList,
        },
      };
    }

    case CloudflareActionTypes.EDIT_RULE_LOADING: {
      return {
        ...state,
        rules: {
          ...state.rules,
          edit: {
            ...state.rules.edit,
            loading: action.payload,
          },
        },
      };
    }

    case CloudflareActionTypes.SET_SINGLE_RULE_LOADING: {
      const newList = state.rules.list.map((item) => {
        if (item.rule_id === action.payload.ruleId) {
          return {
            ...item,
            loading: action.payload.isLoading,
          };
        }
        return item;
      });

      return {
        ...state,
        rules: {
          ...state.rules,
          list: newList,
        },
      };
    }

    case CloudflareActionTypes.SET_RULE_FORM_DATA: {
      return {
        ...state,
        rules: {
          ...state.rules,
          submitAction: action.payload.submitAction,
          ruleData: {
            ruleId: action.payload.ruleData.rule_id,
            description: action.payload.ruleData.description,
            lockType: action.payload.ruleData.lock_type,
            value: action.payload.ruleData.value,
            enabled: action.payload.ruleData.enabled,
          },
        },
      };
    }

    case CloudflareActionTypes.TOGGLE_RULE_STATUS_SET: {
      return {
        ...state,
        rules: {
          ...state.rules,
          list: action.payload.newList,
        },
      };
    }

    default:
      return state;
  }
};

export default cloudflareReducer;
